import { Phone, Mail, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const navigate = useNavigate();
    return (
        <footer className="bg-[#1B2C3E] text-gray-700 py-12 px-4 sm:px-6 lg:px-8 border-t border-gray-200">
            <div className="max-w-6xl mx-auto">
                {/* Main Footer Content */}
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 ">
                    {/* Company Info */}
                    <div className="space-y-4 col-span-2 md:col-span-1">
                        <div>
                            <img src='/Logo.png' className='w-52'/>
                            <p className="text-xs md:text-sm text-gray-100 mt-1 w-[80%] md:w-full">
                                Premium transportation services in Hyderabad with reliability and comfort.
                            </p>
                        </div>
                        <div className="flex space-x-4">
                            <a href="#" className="text-gray-50 hover:text-indigo-300 transition-colors">
                                <Facebook size={20} />
                            </a>
                            <a href="#" className="text-gray-50 hover:text-indigo-300 transition-colors">
                                <Twitter size={20} />
                            </a>
                            <a href="#" className="text-gray-50 hover:text-indigo-300 transition-colors">
                                <Instagram size={20} />
                            </a>
                            <a href="#" className="text-gray-50 hover:text-indigo-300 transition-colors">
                                <Linkedin size={20} />
                            </a>
                        </div>
                    </div>

                    {/* Services */}
                    <div >
                        <h3 className="text-sm md:text-lg text-gray-300 font-semibold uppercase mb-2">
                            Our Services
                        </h3>
                        <ul className="space-y-2 text-xs md:text-sm">
                            <li
                                onClick={() => navigate('/employee-transportation')}
                                className="flex items-start text-white cursor-pointer px-2 py-1 hover:bg-gray-800 rounded"
                            >
                                <span className="text-indigo-600 mr-2">•</span>
                                <span>Employee Transportation</span>
                            </li>
                            <li
                                onClick={() => navigate('/corporate-car')}
                                className="flex items-start text-white cursor-pointer px-2 py-1 hover:bg-gray-800 rounded"
                            >
                                <span className="text-indigo-600 mr-2">•</span>
                                <span>Corporate Car Services</span>
                            </li>
                            <li
                                onClick={() => navigate('/airport-transfer')}
                                className="flex items-start text-white cursor-pointer px-2 py-1 hover:bg-gray-800 rounded"
                            >
                                <span className="text-indigo-600 mr-2">•</span>
                                <span>Airport Transfers</span>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-sm md:text-lg text-gray-300 font-semibold uppercase mb-2">Contact Us</h3>
                        <address className="not-italic text-xs md:text-sm space-y-3 text-white">
                            <div className="flex items-start">
                                <MapPin className="text-indigo-600 mt-0.5 mr-2 flex-shrink-0" size={16} />
                                <span>
                                    Udaya Vensar Jubilee Garden,<br />
                                    Flat No. 601, Kondapur<br />
                                    Hyderabad, Telangana - 500084
                                </span>
                            </div>
                        </address>
                    </div>

                    {/* Reach Us */}
                    <div>
                        <h3 className="text-sm md:text-lg text-gray-300 font-semibold uppercase mb-2">Reach Us</h3>
                        <div className="space-y-3 text-xs md:text-sm text-white">
                            <div className="flex items-center">
                                <Phone className="text-indigo-600 mr-2" size={16} />
                                <a href="tel:+917993149818" className="hover:text-indigo-600 transition-colors">
                                    +91 79931 49818
                                </a>
                            </div>
                            <div className="flex items-center">
                                <Phone className="text-indigo-600 mr-2" size={16} />
                                <a href="tel:+917680898831" className="hover:text-indigo-600 transition-colors">
                                    +91 76808 98831
                                </a>
                            </div>
                            <div className="flex items-center">
                                <Mail className="text-indigo-600 mr-2" size={16} />
                                <a href="mailto:satish@pvrcabs.com" className="hover:text-indigo-600 transition-colors">
                                    satish@pvrcabs.com
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className="border-t border-gray-200 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center">
                    <div className="text-[10px] md:text-xs text-gray-50 mb-4 md:mb-0">
                        © {new Date().getFullYear()} PVR CABS. All rights reserved.
                    </div>
                    <div className="flex space-x-6">
                        <a href="#" className="text-[10px] md:text-xs text-gray-50 hover:text-indigo-300 transition-colors">
                            Privacy Policy
                        </a>
                        <a href="#" className="text-[10px] md:text-xs text-gray-50 hover:text-indigo-300 transition-colors">
                            Terms of Service
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
